var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinanceBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57745 32.4999C9.57745 32.4999 -6.33965 26.7877 3.59818 9.0332C3.59818 9.0332 2.65961 15.2007 4.29935 18.9239C5.93909 22.6471 8.19167 25.8284 9.57745 32.4999Z",
    fill: "url(#paint0_linear_11_7434)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 32.4997C14.3083 31.8104 16.0296 30.7368 17.4754 29.3475C19.0772 27.8177 20.2921 25.9318 21.0203 23.8443C21.865 21.1331 21.8817 18.2333 21.0683 15.5126C20.5429 13.4433 19.6394 11.4879 18.4029 9.74414C18.6778 12.6003 18.4009 15.4825 17.5873 18.235C16.8624 20.6231 16.0521 21.7216 14.826 24.7199C13.7995 27.2389 12.995 29.8419 12.4219 32.4997Z",
    fill: "url(#paint1_linear_11_7434)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4167 26.8111C11.9813 26.8111 12.3416 25.6131 13.3634 22.9978C14.0194 21.3238 14.2829 20.896 14.5679 20.083C14.9 19.1972 15.1696 18.2893 15.3746 17.3661C16.1984 13.8183 16.1782 10.1281 15.3154 6.58942C14.8537 5.0782 14.1589 3.64744 13.2558 2.34826C12.4223 1.15025 12.0028 0.551246 11.3952 0.503111C9.78192 0.374753 8.06648 4.24689 7.35126 6.73917C6.45215 10.3991 6.5356 14.2297 7.59325 17.8475C7.95893 19.008 8.49668 20.3932 8.49668 20.3932C8.89462 21.4094 9.12586 21.7464 9.57219 22.9978C10.524 25.458 10.8252 26.8004 11.4167 26.8111Z",
    fill: "url(#paint2_linear_11_7434)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_7434",
    x1: 0.440159,
    y1: 14.0029,
    x2: 11.4854,
    y2: 31.4617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1A77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1A2DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3D52EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3182D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_7434",
    x1: 21.9425,
    y1: 13.6553,
    x2: 10.9893,
    y2: 31.0583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1A77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1A2DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3D52EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3182D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#30C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_7434",
    x1: 11.3414,
    y1: 3.78694,
    x2: 11.3414,
    y2: 30.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1A77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1A2DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3D52EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3182D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30C8FF"
  })))));
}

export default __webpack_public_path__ + "media/cf6ba416.svg";
export { SvgFinanceBlue as ReactComponent };